import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"height":"100%","flat":_vm.flat}},[_c(VCardTitle,{staticClass:"font-weight-black"},[_vm._v(_vm._s(_vm.$t('delivery.product.products')))]),_c(VCardText,{staticClass:"text-left"},[_c('order-items',{attrs:{"md":"12","items":_vm.order.items}}),_c('cart-total',{attrs:{"order":_vm.order}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }